module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/pennant.svg?627b930fe7cc2fcf17d51926da145922";